import ABackPage from './index.vue';

ABackPage.install = app => {
  app.component(ABackPage.name, ABackPage);
};

export default ABackPage;
